import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import AppCategoriesHeader from '~/components/Layout/AppCategoriesHeader.vue';
import { cacheControl } from '~/helpers/cacheControl';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import CategoryPageHeader from '~/components/Product/Category/CategoryPageHeader.vue';
import BlockCategoryTagsGraphql from '~/components/Organisms/BlockCategoryTagsGraphql.vue';
import AzRichText from '~/components/_next/atoms/AzRichText.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import SearchFiltersOrganism from '~/components/_next/organisms/search/SearchFiltersOrganism.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { createRichTextLinksMap } from '~/composables/useParseDocumentToHtml/HTMLParserOptions';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { useAdviceListingStore } from '~/composables/_next/stores/useAdviceListingStore';
import { useSegment } from '~/composables/_next/useSegment';
import { useWait } from '~/composables/_next/useWait';
import AzAdviceCard from '~/components/_next/molecules/AzAdviceCard.vue';
import CardSkeleton from '~/assets/images/skeletons/card.svg?inline';
import { watchDebounced } from '@vueuse/core';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
      ],tracking: {
        category: TrackingPageCategory.ALP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: '_slug',
  setup: function setup(__props) {
    var RelatedAdvicesOrganism = function RelatedAdvicesOrganism() {
      return import('~/components/_next/organisms/RelatedAdvicesOrganism.vue');
    };
    var AzSeoBlock = function AzSeoBlock() {
      return import('~/components/_next/molecules/AzSeoBlock.vue');
    };
    ;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var route = useRoute();
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(TrackingPageCategory.ALP, PageTypes.ALP);
    });
    var _useSearchFacets = useSearchFacets(),
      facets = _useSearchFacets.facets,
      clearSearchFacets = _useSearchFacets.clearSearchFacets;
    var _useNuxt2App = useNuxt2App(),
      error = _useNuxt2App.error,
      $trackers = _useNuxt2App.$trackers,
      i18n = _useNuxt2App.i18n,
      app = _useNuxt2App.app;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta;
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;
    var sidebar = ref(null);
    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      sidebar.value.sidebar.showModal();
    }
    /**
     * Closes the filters sidebar.
     */
    function closeSidebar() {
      sidebar.value.sidebar.close();
    }
    function onClearFilters() {
      return _onClearFilters.apply(this, arguments);
    }
    function _onClearFilters() {
      _onClearFilters = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return clearSearchFacets();
            case 2:
              closeSidebar();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _onClearFilters.apply(this, arguments);
    }
    var _useAdviceListingStor = useAdviceListingStore(),
      adviceListingSort = _useAdviceListingStor.adviceListingSort,
      advices = _useAdviceListingStor.advices,
      adviceListingCategories = _useAdviceListingStor.adviceListingCategories,
      fetchAdviceListingContent = _useAdviceListingStor.fetchAdviceListingContent,
      adviceListingContent = _useAdviceListingStor.adviceListingContent,
      adviceListingPagination = _useAdviceListingStor.adviceListingPagination,
      relatedAdvices = _useAdviceListingStor.relatedAdvices;
    var _useLazyAsyncData = useLazyAsyncData("advice-listing-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _advices$value, _adviceListingContent, _adviceListingContent2;
        var seo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchAdviceListingContent();
            case 3:
              _context.next = 9;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              error({
                statusCode: 404
              });
              return _context.abrupt("return", true);
            case 9:
              if (!(!((_advices$value = advices.value) !== null && _advices$value !== void 0 && _advices$value.length) && !adviceListingCategories.value.length)) {
                _context.next = 12;
                break;
              }
              error({
                statusCode: 404
              });
              return _context.abrupt("return", true);
            case 12:
              seo = _objectSpread(_objectSpread({
                title: (_adviceListingContent = adviceListingContent.value) === null || _adviceListingContent === void 0 ? void 0 : _adviceListingContent.title
              }, (_adviceListingContent2 = adviceListingContent.value) === null || _adviceListingContent2 === void 0 ? void 0 : _adviceListingContent2.seo), {}, {
                slug: transformSlugsForSeo(adviceListingContent.value)
              });
              setMeta(seo);
              return _context.abrupt("return", true);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }))),
      loading = _useLazyAsyncData.pending;
    watchDebounced(facets, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchAdviceListingContent();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), {
      immediate: false,
      throttle: 1000
    });
    watch(function () {
      var _route$query;
      return (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.page;
    }, function (page, oldPage) {
      if (page !== oldPage) {
        window.scrollTo(0, 0);
      }
    }, {
      immediate: false
    });
    var breadcrumbs = computed(function () {
      var _adviceListingContent3, _adviceListingContent4, _adviceListingContent9, _adviceListingContent0;
      var crumbs = [{
        link: app.localePath({
          name: 'index'
        }),
        text: i18n.t('utils.homeBreadcrumbs')
      }];
      if ((_adviceListingContent3 = adviceListingContent.value) !== null && _adviceListingContent3 !== void 0 && (_adviceListingContent4 = _adviceListingContent3.parentAdviceListingPage) !== null && _adviceListingContent4 !== void 0 && _adviceListingContent4.slug) {
        var _adviceListingContent5, _adviceListingContent6, _adviceListingContent7, _adviceListingContent8;
        crumbs.push({
          link: app.localePath({
            name: 'pages-slug',
            params: {
              slug: (_adviceListingContent5 = adviceListingContent.value) === null || _adviceListingContent5 === void 0 ? void 0 : (_adviceListingContent6 = _adviceListingContent5.parentAdviceListingPage) === null || _adviceListingContent6 === void 0 ? void 0 : _adviceListingContent6.slug
            }
          }),
          text: (_adviceListingContent7 = adviceListingContent.value) === null || _adviceListingContent7 === void 0 ? void 0 : (_adviceListingContent8 = _adviceListingContent7.parentAdviceListingPage) === null || _adviceListingContent8 === void 0 ? void 0 : _adviceListingContent8.title
        });
      }
      crumbs.push({
        link: app.localePath({
          name: 'pages-slug',
          params: {
            slug: (_adviceListingContent9 = adviceListingContent.value) === null || _adviceListingContent9 === void 0 ? void 0 : _adviceListingContent9.slug
          }
        }),
        text: (_adviceListingContent0 = adviceListingContent.value) === null || _adviceListingContent0 === void 0 ? void 0 : _adviceListingContent0.title
      });
      return crumbs;
    });
    var selectedSort = computed(function () {
      var currentSort = adviceListingSort.value.selected;
      var currentSortPosition = adviceListingSort.value.options.findIndex(function (sort) {
        return sort.id === currentSort;
      });
      return currentSortPosition !== 0 ? currentSort : undefined;
    });
    var isFilterButtonVisible = ref(true);
    var isCategoryPage = computed(function () {
      var _adviceListingCategor;
      return !!((_adviceListingCategor = adviceListingCategories.value) !== null && _adviceListingCategor !== void 0 && _adviceListingCategor.length);
    });
    var itemCount = computed(function () {
      var _ref3, _adviceListingCategor2, _adviceListingPaginat;
      return (_ref3 = isCategoryPage ? (_adviceListingCategor2 = adviceListingCategories.value) === null || _adviceListingCategor2 === void 0 ? void 0 : _adviceListingCategor2.length : (_adviceListingPaginat = adviceListingPagination.value) === null || _adviceListingPaginat === void 0 ? void 0 : _adviceListingPaginat.count) !== null && _ref3 !== void 0 ? _ref3 : 0;
    });
    var headerText = computed(function () {
      return isCategoryPage.value ? 'search.adviceCategoriesCount' : 'search.advicesCount';
    });
    var seoBlock = computed(function () {
      var _adviceListingContent1, _adviceListingContent10, _adviceListingContent11, _adviceListingContent12, _adviceListingContent13, _adviceListingContent14, _adviceListingContent15, _adviceListingContent16;
      var description = (_adviceListingContent1 = adviceListingContent.value) === null || _adviceListingContent1 === void 0 ? void 0 : (_adviceListingContent10 = _adviceListingContent1.seoBlock) === null || _adviceListingContent10 === void 0 ? void 0 : (_adviceListingContent11 = _adviceListingContent10.content) === null || _adviceListingContent11 === void 0 ? void 0 : _adviceListingContent11.json;
      if (!description) return null;
      return {
        title: (_adviceListingContent12 = adviceListingContent.value) === null || _adviceListingContent12 === void 0 ? void 0 : (_adviceListingContent13 = _adviceListingContent12.seoBlock) === null || _adviceListingContent13 === void 0 ? void 0 : _adviceListingContent13.title,
        description: description,
        links: createRichTextLinksMap((_adviceListingContent14 = adviceListingContent.value) === null || _adviceListingContent14 === void 0 ? void 0 : (_adviceListingContent15 = _adviceListingContent14.seoBlock) === null || _adviceListingContent15 === void 0 ? void 0 : (_adviceListingContent16 = _adviceListingContent15.content) === null || _adviceListingContent16 === void 0 ? void 0 : _adviceListingContent16.links)
      };
    });
    function changeSort(_x) {
      return _changeSort.apply(this, arguments);
    }
    function _changeSort() {
      _changeSort = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(sort) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              startWaiter('sort.change');
              _context4.next = 3;
              return fetchAdviceListingContent(sort);
            case 3:
              endWaiter('sort.change');
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _changeSort.apply(this, arguments);
    }
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Advice_Listing_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Advice_Listing_Page']);
    return {
      __sfc: true,
      RelatedAdvicesOrganism: RelatedAdvicesOrganism,
      AzSeoBlock: AzSeoBlock,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      route: route,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      facets: facets,
      clearSearchFacets: clearSearchFacets,
      error: error,
      $trackers: $trackers,
      i18n: i18n,
      app: app,
      setMeta: setMeta,
      transformSlugsForSeo: transformSlugsForSeo,
      sidebar: sidebar,
      openSidebar: openSidebar,
      closeSidebar: closeSidebar,
      onClearFilters: onClearFilters,
      adviceListingSort: adviceListingSort,
      advices: advices,
      adviceListingCategories: adviceListingCategories,
      fetchAdviceListingContent: fetchAdviceListingContent,
      adviceListingContent: adviceListingContent,
      adviceListingPagination: adviceListingPagination,
      relatedAdvices: relatedAdvices,
      loading: loading,
      breadcrumbs: breadcrumbs,
      selectedSort: selectedSort,
      isFilterButtonVisible: isFilterButtonVisible,
      isCategoryPage: isCategoryPage,
      itemCount: itemCount,
      headerText: headerText,
      seoBlock: seoBlock,
      changeSort: changeSort,
      AzBackToTopButton: AzBackToTopButton,
      AppCategoriesHeader: AppCategoriesHeader,
      AzPagination: AzPagination,
      CategoryPageHeader: CategoryPageHeader,
      BlockCategoryTagsGraphql: BlockCategoryTagsGraphql,
      AzRichText: AzRichText,
      AzButton: AzButton,
      AzSidebar: AzSidebar,
      SearchFiltersOrganism: SearchFiltersOrganism,
      MobileFiltersButton: MobileFiltersButton,
      AzIcon: AzIcon,
      AzAdviceCard: AzAdviceCard,
      CardSkeleton: CardSkeleton
    };
  }
});